<template>
    <div>
        <b-button variant="dark" size="sm"><b-icon icon="eye" @click="open"/></b-button>
        <main-dialog v-model="openModal" hide-header hide-footer>    
            <tree-view :data="value" :options="{maxDepth: 3}"></tree-view>
        </main-dialog>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object
        },
        itemField: {
            type: Object
        },
        value: {
            type: String | Number | Object
        }
    },

    data: function() {
        return {
            openModal: false
        }
    },

    methods: {
        open(e) {
            e.stopImmediatePropagation();

            this.openModal = true;
        },
    },

    computed: { },

    mounted() {
        
    }
}
</script>